import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useContent } from "@/lib/content";

export const LEGAL_DOCS = {
  privacy: { key: "legal.privacy", label: "Privacy Policy" },
  terms: { key: "legal.terms", label: "Terms & Conditions" },
  refund: { key: "legal.refund", label: "Refund & Cancellation Policy" },
};

/** A numbered clause ("3. Consultations") becomes a heading; everything else is body copy. */
const isHeading = (line) => /^\d+\.\s/.test(line.trim());

export default function Legal() {
  const { doc } = useParams();
  const { c } = useContent();
  const entry = LEGAL_DOCS[doc];
  if (!entry) return <Navigate to="/legal/privacy" replace />;

  const body = c(`${entry.key}.body`, "");
  const blocks = body.split(/\n{2,}/).filter(Boolean);

  return (
    <main className="max-w-3xl mx-auto px-6 lg:px-12 py-14" data-testid={`legal-page-${doc}`}>
      <div className="overline mb-3">Legal</div>
      <h1 className="font-display text-4xl sm:text-5xl mb-8" data-testid="legal-title">
        {c(`${entry.key}.title`, entry.label)}
      </h1>
      <div className="space-y-5">
        {blocks.map((block, i) =>
          isHeading(block.split("\n")[0]) ? (
            <div key={i}>
              <h2 className="font-display text-xl mb-1.5">{block.split("\n")[0]}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
                {block.split("\n").slice(1).join("\n")}
              </p>
            </div>
          ) : (
            <p key={i} className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
              {block}
            </p>
          )
        )}
      </div>
    </main>
  );
}
